module.exports = __webpack_public_path__ + "assets/img/txt-mv.01e9a304.svg";